/**
 * Exposes the app's single `SupabaseAuth` instance to components that need
 * more than `GameProvider`'s narrow `AuthClientLike` surface (e.g. Settings'
 * "Mit E-Mail sichern"/"Abmelden" — `upgradeToEmailAccount`, `signOut`).
 * Deliberately separate from `GameProvider` so the game-state container
 * keeps depending only on the small structural interface it actually uses.
 */

import { createContext, useContext, type ReactNode } from 'react';
import type { SupabaseAuth } from './supabase-auth';

const AuthContext = createContext<SupabaseAuth | null>(null);

export function AuthProvider({ auth, children }: { auth: SupabaseAuth; children: ReactNode }) {
  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}

export function useAuth(): SupabaseAuth {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside <AuthProvider>.');
  return ctx;
}
